const routes = [
  {
    path: '/video-categories',
    name: 'video-categories',
    meta: {
      authRequired: true,
      permission: 'video.list'
    },
    component: () => import('./Index.vue')
  }
]

export default routes
